namespace $.$$ {

	$mol_style_define( $shm_hitalama_tabulator, {

		position: 'absolute',
		left: 0,
		top: 0,
		width: '100%',
		height: '100%',
		display: 'block',
		font: {
			family: 'inherit',
		},

	} as any )

}
